export default (isp, timeWindow) => {
  if (!isp) {
    return false
  }
  
  const options = (timeWindow ? isp.filter(s => s.window_size === timeWindow) : isp).slice().sort((a, b) => b.window_size - a.window_size)
  if (options.length > 0) {
    return options[0]
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/get_isp_data.js